var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("g-g-app-modal", {
    attrs: {
      "is-active": _vm.value,
      width: _vm.$vuetify.breakpoint.mdAndUp ? "750px" : "90%",
      "close-button-positions": ["title", "footer"]
    },
    on: {
      close: _vm.closeModal
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function fn() {
          return [
            _c(
              "div",
              {
                staticClass: "mr-auto ml-auto",
                staticStyle: {
                  "text-align": "start"
                }
              },
              [
                _vm._v(" Powered by LiteSpeed & LSCache "),
                _c(
                  "v-icon",
                  {
                    staticClass: "ml-3",
                    attrs: {
                      color: "primary",
                      small: ""
                    }
                  },
                  [_vm._v("mdi-checkbox-marked-circle")]
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c(
              "v-row",
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-wrap": "wrap"
                    }
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-auto",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c("v-img", {
                          staticClass: "d-flex align-center ma-auto",
                          attrs: {
                            src: "/static/img/wizard/litespeed-logo.png",
                            height: "140",
                            width: "140"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-2"
                          },
                          [
                            _vm._v(
                              " GreenGeeks websites run on LiteSpeed servers, so you can take full advantage of the LiteSpeed Cache website acceleration plugin. With advanced cache-management tools and optimization features. LSCache for WordPress is an all-in-one site acceleration solution. It's the only optimization plugin you need! "
                            )
                          ]
                        ),
                        _c("p", [
                          _vm._v(
                            " Caching via LiteSpeed is activated by default so your site can employ the best practices that make for a high PageSpeed score, and more importantly an incredible user experience . You can disable this at any time from within your WP Dashboard. "
                          )
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-col",
                  {
                    attrs: {
                      cols: "12",
                      md: "12"
                    }
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-clipboard-arrow-down-outline")]
                            ),
                            _vm._v(" Server-Level Full-Page Cache ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-lock")]
                            ),
                            _vm._v(" Private Cache ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-checkbox-blank-circle-outline")]
                            ),
                            _vm._v(" Edge Side Includes (ESI) ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-image-size-select-actual")]
                            ),
                            _vm._v(" Image Optimization ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-cogs")]
                            ),
                            _vm._v(" Crawler ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-arrow-collapse-vertical")]
                            ),
                            _vm._v(" CSS/JavaScript/HTML Minify ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-folder-outline")]
                            ),
                            _vm._v(" CSS/JavaScript Combination ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-telegram")]
                            ),
                            _vm._v(" HTTP/2 Push ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-cloud-download")]
                            ),
                            _vm._v(" Content Delivery Network Support ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-file-code-outline")]
                            ),
                            _vm._v(" Browser Cache Support ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-image-frame")]
                            ),
                            _vm._v(" Lazy Load Images ")
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12",
                              sm: "6"
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: {
                                  medium: "",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-database")]
                            ),
                            _vm._v(" Database Optimization ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }